// extracted by mini-css-extract-plugin
module.exports = {"container":"MediaLayer_container___RFDD","base":"MediaLayer_base__IeX4H","variant":"MediaLayer_variant__5cUaw","active":"MediaLayer_active__Pb2Q4"};